export function isEmptyOrSpaces(str: string | null | undefined) {
  return !str || str.match(/^ *$/) !== null;
}

export function formatMoney(symbol: string, value: number) {
  return `${symbol}${Number(value).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
